import Table from "../components/examinations-status/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import SearchBar from "../components/examinations-status/SearchBar";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../app/hook";
import { stringToBoolean } from "../components/default-constants";
import {
  INITIAL_SEARCH_CRITERIA,
  setSearchCriteria,
} from "../features/slices/examinations-status-list";

/**
 * 審査状況照会
 */
const ExaminationsStatus = () => {
  useAuthenticationHook(PERMISSIONS.EXAMINE);
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(search);
  const isBackFromDetail = stringToBoolean(query.get("isBackFromDetail"));
  const [skip, setSkip] = useState(true);

  useEffect(() => {
    if (!isBackFromDetail) {
      dispatch(setSearchCriteria(INITIAL_SEARCH_CRITERIA));
    } else {
      setSkip(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <SpaceBetween direction={"vertical"} size={"l"}>
      <SearchBar setSkip={setSkip} />
      <Table isBackFromDetail={isBackFromDetail} skip={skip} />
    </SpaceBetween>
  );
};

export default ExaminationsStatus;
